import { useState } from "react";
import { track } from "../../../lib/analytics";
import { useJoinWaitlist } from "../../../lib/api/waitlist.api";

export function WaitlistSection({
  email,
  hasAttemptedRegister,
  registerIsError,
}: {
  readonly email: string;
  readonly hasAttemptedRegister: boolean;
  readonly registerIsError: boolean;
}) {
  const [waitlistDone, setWaitlistDone] = useState(false);
  const joinWaitlist = useJoinWaitlist();

  if (!hasAttemptedRegister || !registerIsError) {
    return null;
  }

  return (
    <div className="bg-surface-alt border border-border rounded-xl p-4 flex flex-col gap-2 text-center">
      {waitlistDone ? (
        <p className="text-xs text-emerald-500 font-medium">
          Vous êtes inscrit à la waitlist !
        </p>
      ) : (
        <>
          <p className="text-xs text-ink-muted">
            Pas encore prêt ? Rejoignez la waitlist pour être informé du lancement.
          </p>
          <button
            type="button"
            disabled={!email.trim() || joinWaitlist.isPending}
            onClick={() => {
              joinWaitlist.mutate(
                { email: email.trim() },
                {
                  onSuccess: () => {
                    setWaitlistDone(true);
                    track("waitlist_submitted", {});
                  },
                },
              );
            }}
            className="self-center px-4 py-2 text-xs font-medium border border-accent text-accent rounded-lg
              hover:bg-accent/10 disabled:opacity-40 transition-colors"
          >
            {joinWaitlist.isPending ? "..." : "Rejoindre la waitlist"}
          </button>
          {joinWaitlist.isError && (
            <p className="text-[11px] text-red-500">
              {(joinWaitlist.error as Error).message}
            </p>
          )}
        </>
      )}
    </div>
  );
}
